import { render, staticRenderFns } from "./ActivityLogTable.vue?vue&type=template&id=2748647d&scoped=true"
import script from "./ActivityLogTable.vue?vue&type=script&lang=ts"
export * from "./ActivityLogTable.vue?vue&type=script&lang=ts"
import style0 from "./ActivityLogTable.vue?vue&type=style&index=0&id=2748647d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2748647d",
  null
  
)

export default component.exports